module.exports = __webpack_public_path__ + "img/cancercouncil.bad817d.png";